import Icon, { type IconString } from '2-core-elements/Icon/Icon';

export type TagProps = {
    label: string;
    skin?: 'brand-1' | 'brand-2' | 'brand-3' | 'brand-4' | 'neutral' | 'success' | 'error' | 'warning' | 'info';
    variant?: 'primary' | 'secondary' | 'tertiary';
    size?: 'sm' | 'md' | 'lg';
    prefixIcon?: IconString;
};

const Chip = ({ skin = 'brand-1', variant = 'primary', label, size = 'md', prefixIcon }: TagProps): JSX.Element => {
    return (
        <div className={`badge badge-${skin} badge-${variant} badge-${size}`}>
            {prefixIcon && <Icon icon={prefixIcon} />}
            {label}
        </div>
    );
};

export default Chip;
